<template>
  <div class="shopping">
    <!-- <button @click="test">ssssssss</button> -->
    <form action="" class="shopping--form" v-if="edit_show">
      <a
        @click.prevent="edit_show = false"
        href=""
        class="shopping--form-close"
      >
        <font-awesome-icon icon="times-circle" />
      </a>
      <div>
        <div class="in2">
          <div class="bo1">
            <label class="la" for="">استان *</label>
            <multiselect
              v-model="eddit.pri"
              :options="options_city"
              placeholder="استان"
              label="name"
              track-by="name"
              :searchable="true"
              :taggable="true"
              style="width: '200px'"
            >
            </multiselect>
          </div>
          <div class="bo">
            <label class="la" for="">شهر *</label>
            <input v-model="eddit.city" type="text" placeholder="شهر" />
          </div>
        </div>
        <label class="la" for="">نشانی *</label>
        <input
          style="margin-bottom: 0.5em"
          v-model="eddit.add"
          placeholder="نشانی"
          type="text"
        />
        <!-- <input type="text" /> -->
        <div class="in2">
          <div class="b3">
            <label class="la" for="">کد پستی *</label>
            <input
              class="i3"
              type="text"
              v-model="eddit.zipc"
              placeholder="کد پستی"
            />
          </div>
        </div>
        <hr class="rrrr" />
        <div class="in3">
          <div class="i7">
            <label class="la" for="">نام گیرنده *</label>
            <input
              class="b4"
              v-model="eddit.fname"
              placeholder="نام گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">نام خانوادگی گیرنده *</label>
            <input
              class="b4"
              v-model="eddit.lname"
              placeholder="نام خانوادگی گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">کدملی </label>
            <input
              class="b4"
              v-model="eddit.nanu"
              placeholder="کد ملی"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">شماره موبایل *</label>
            <input
              class="b4"
              v-model="eddit.pho"
              placeholder="شماره موبایل"
              type="text"
            />
          </div>
          <div class="i8">
            <label class="la" for="">تلفن ثابت به همراه کد شهر *</label>
            <input
              class="b5"
              v-model="eddit.tel"
              placeholder="تلفن ثابت به همراه کد شهر"
              type="text"
            />
          </div>
          <hr class="rrrr" />
          <button @click.prevent="edit_add" class="bbb">ویرایش نشانی</button>
        </div>
      </div>
    </form>
    <form action="" class="shopping--form" v-if="create_show">
      <a
        @click.prevent="create_show = false"
        href=""
        class="shopping--form-close"
      >
        <font-awesome-icon icon="times-circle" />
      </a>
      <div>
        <div class="in1">
          <div class="bo1">
            <label class="la" for="">استان *</label>
            <multiselect
              v-model="create.pri"
              :options="options_city"
              placeholder="استان"
              label="name"
              track-by="name"
              :searchable="true"
              :taggable="true"
            >
            </multiselect>
          </div>
          <div class="bo">
            <label class="la" for="">شهر *</label>
            <input type="text" v-model="create.city" placeholder="شهر" />
          </div>
        </div>
        <label class="la" for="">نشانی *</label>
        <input
          style="margin-bottom: 0.5em"
          v-model="create.add"
          placeholder="نشانی"
          type="text"
        />
        <!-- <input type="text" /> -->
        <div class="in2">
          <div class="b3">
            <label class="la" for="">کد پستی *</label>
            <input
              class="i3"
              v-model="create.zipc"
              type="text"
              placeholder="کد پستی"
            />
          </div>
        </div>
        <hr class="rrrr" />
        <div class="in3">
          <div class="i7">
            <label class="la" for="">نام گیرنده *</label>
            <input
              class="b4"
              v-model="create.fname"
              placeholder="نام گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">نام خانوادگی گیرنده *</label>
            <input
              class="b4"
              v-model="create.lname"
              placeholder="نام خانوادگی گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">کدملی </label>
            <input
              class="b4"
              v-model="create.nanu"
              placeholder="کد ملی"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">شماره موبایل *</label>
            <input
              class="b4"
              v-model="create.pho"
              placeholder="شماره موبایل"
              type="text"
            />
          </div>
          <div class="i8">
            <label class="la" for="">تلفن ثابت به همراه کد شهر *</label>
            <input
              class="b5"
              v-model="create.tel"
              placeholder="تلفن ثابت به همراه کد شهر"
              type="text"
            />
          </div>
          <hr class="rrrr" />
          <button class="bbb" @click.prevent="create__address">
            ایجاد نشانی جدید
          </button>
        </div>
      </div>
    </form>
    <div class="shopping__detail">
      <div class="shopping__detail--address">
        <h3 class="shopping__detail--address-h3">
          آدرس تحویل سفارش را انتخاب کنید:
        </h3>
        <p class="shopping__detail--address-p">‌آدرس خود رو انتخاب کنید</p>
        <div class="shopping__detail--address-items">
          <a
            href=""
            class="shopping__detail--address-items-item"
            :key="(item, index)"
            v-for="(item, index) in add_list"
            @click.prevent="(address = item.id), (addpri = item.province)"
            :class="[address == item.id ? 'aaa' : '']"
          >
            <input type="hidden" :value="item.province" />
            <div class="">
              <p class="shopping__detail--address-items-item-add">
                {{ item.get_province_display }} , {{ item.city }} ,
                {{ item.address }}
              </p>
              <p class="shopping__detail--address-items-item-zipc">
                <font-awesome-icon icon="user-edit" />
                {{ item.zip_code.toPersianDigits() }}
              </p>
              <p class="shopping__detail--address-items-item-pho">
                <font-awesome-icon icon="user-edit" />
                {{ item.cellphone.toPersianDigits() }}
              </p>
              <p class="shopping__detail--address-items-item-name">
                <font-awesome-icon icon="user-edit" />
                {{ item.first_name }} {{ item.last_name }}
              </p>
            </div>

            <div class="shopping__detail--address-items-item-edit">
              <a
                class="shopping__detail--address-items-item-edit-del"
                href=""
                @click.prevent="delete_add_cart"
                >حذف</a
              >
              <a
                class="shopping__detail--address-items-item-edit-edi"
                @click.prevent="open_edit"
                href=""
                >ویرایش</a
              >
              <input type="hidden" :value="item.id" />
            </div>
          </a>
          <a
            v-if="add_list.length < 3"
            href=""
            class="shopping__detail--address-items-add"
            @click.prevent="create_show = true"
          >
            <font-awesome-icon icon="plus" />
            <p>ایجاد آدرس جدید</p>
          </a>
        </div>
      </div>
      <div class="shopping__detail--marsole">
        <h3 class="shopping__detail--marsole-h3">مرسوله:</h3>
        <p class="shopping__detail--marsole-p">کالاهای مجاز</p>
        <div class="shopping__detail--marsole-items">
          <div
            :key="(item, index)"
            v-for="(item, index) in valid"
            class="shopping__detail--marsole-items-item"
          >
            <img
              class="shopping__detail--marsole-items-item-img"
              :src="item.image"
              :alt="item.image"
            />
            <div
              v-if="item.color"
              class="shopping__detail--marsole-items-item-color"
            >
              <p
                style="margin-top: 0.2em; margin-right: 0.3em"
                class="shopping__detail--marsole-items-item-color-name"
              >
                {{ item.color.name }}
              </p>
              <div
                class="shopping__detail--marsole-items-item-color-div"
                :style="{ background: item.color.color }"
              ></div>
            </div>
            <div
              v-if="item.essence"
              class="shopping__detail--marsole-items-item-color"
            >
              <p
                style="margin-top: 0.2em; margin-right: 0.3em"
                class="shopping__detail--marsole-items-item-color-name"
              >
                اسانس : {{ item.essence }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="shopping__detail--marsole">
        <h3 class="shopping__detail--marsole-h3">تخفیف:</h3>
        <div class="in33">
          <div class="bo33">
            <!-- <label class="la" for="">استان *</label> -->
            <multiselect
              v-model="decodee"
              :options="decode"
              placeholder="کد تخفیف"
              label="amount"
              track-by="amount"
              :searchable="true"
              :taggable="true"
              :custom-label="nameWithLang"
              @select="codeins"
              @remove="codeinss"
            >
            </multiselect>
          </div>
          <!-- <a class="acc" name="acc" @click.prevent="codeins">ثبت کد</a>
          <a class="err" name="err" @click.prevent="codeins">حذف</a> -->
        </div>
      </div>
      <div class="shopping__detail--address">
        <h3 class="shopping__detail--address-h3">توضیحات :</h3>
        <p class="shopping__detail--address-p">توضیحات خود را ثبت کنید</p>
        <textarea
          v-model="texte"
          class="shopping__detail--texte"
          name=""
          id=""
          cols="30"
          rows="10"
          placeholder="توضیحات"
        ></textarea>
      </div>
      <div class="shopping__detail--address">
        <h3 class="shopping__detail--address-h3">نحوه ارسال کالا:</h3>
        <!-- <h4 class="shopping__detail--address-h3">
          <font-awesome-icon icon="info" /> &nbsp; پرداخت هزینه جابه جایی در محل
          ،طبق تعرفه ها
        </h4> -->
        <p class="shopping__detail--address-p">نحوه ی ارسال را انتخاب کنید</p>
        <div class="shopping__detail--address-items">
          <a
            v-if="addpri == 8 || addpri == ''"
            href=""
            class="shopping__detail--address-items-del"
            @click.prevent="post = 1"
            :class="[post == 1 ? 'aaa' : '']"
          >
            <font-awesome-icon icon="user-edit" />
            پیک تهران
          </a>
          <a
            href=""
            class="shopping__detail--address-items-del"
            @click.prevent="post = 2"
            :class="[post == 2 ? 'aaa' : '']"
          >
            <font-awesome-icon icon="user-edit" />
            پست
          </a>
          <a
            @click.prevent="post = 3"
            :class="[post == 3 ? 'aaa' : '']"
            href=""
            class="shopping__detail--address-items-del"
          >
            <font-awesome-icon icon="user-edit" />
            تیپاکس
          </a>
          <a
            v-if="addpri != 8"
            href=""
            @click.prevent="post = 4"
            :class="[post == 4 ? 'aaa' : '']"
            class="shopping__detail--address-items-del"
          >
            <font-awesome-icon icon="user-edit" />
            باربری
          </a>
        </div>
        <p
          v-if="post == 3"
          class="shopping__detail--address-p"
          style="margin-bottom: 1em"
        >
          {{ idk.tipax }}
        </p>
        <p
          v-if="post == 4"
          class="shopping__detail--address-p"
          style="margin-bottom: 1em"
        >
          {{ idk.freight }}
        </p>
        <p
          v-if="post == 2"
          class="shopping__detail--address-p"
          style="margin-bottom: 1em"
        >
          {{ idk.post }}
        </p>
      </div>

      <div class="shopping__detail--time" v-if="addpri == 8 && post == 1">
        <h3 class="shopping__detail--time-h3">انتخاب زمان ارسال:</h3>
        <p class="shopping__detail--time-p">زمان های قابل دسترس</p>
        <div class="shopping__detail--time--con">
          <swiper class="swiper" ref="swiper" :options="swiperOption">
            <swiper-slide
              class="shopping__detail--time--con-day"
              v-for="(item, index) in dateee"
              :key="(item, index)"
              v-if="checkday(item.perday, item.ishol)"
            >
              <a
                @click.prevent="(idd = index), (delivery_date = item.enyear)"
                :class="[
                  idd == index ? 'aaaa' : '',
                  item.ishol == true ? 'holi' : '',
                ]"
                href=""
              >
                <p>{{ item.perday }}</p>
                <p>{{ item.day.toPersianDigits() }} &nbsp; {{ item.month }}</p>
              </a>
              <input type="hidden" :value="item.enyear" />
            </swiper-slide>
            <div
              class="swiper-button-prev"
              slot="button-prev"
              @click="prev()"
            ></div>
            <div
              class="swiper-button-next"
              slot="button-next"
              @click="next()"
            ></div>
          </swiper>
        </div>

        <div v-if="false" class="shopping__detail--time--con1">
          <div class="">
            <form>
              <div class="radiobtn">
                <input
                  type="radio"
                  id="huey"
                  name="drone"
                  value="1"
                  v-model="time"
                />
                <label for="huey">ساعت ۱۲ تا ۱۵</label>
              </div>

              <div class="radiobtn">
                <input
                  type="radio"
                  id="dewey"
                  name="drone"
                  value="2"
                  v-model="time"
                />
                <label for="dewey">ساعت ۱۵ تا ۱۸</label>
              </div>

              <div class="radiobtn">
                <input
                  type="radio"
                  id="louie"
                  name="drone"
                  value="3"
                  v-model="time"
                />
                <label for="louie">ساعت ۱۸ تا ۲۱</label>
              </div>
            </form>
            <!-- <div class="shopping__detail--time--con1-time">
              <label class="checkbox">
                <span class="ttt">ساعت ۰۹ تا ۱۲</span>
                <input type="radio" />
                <span class="checkmark"></span>
              </label>
              <label class="checkbox">
                <span class="ttt">ساعت ۱۲ تا ۱۵</span>
                <input type="radio" />
                <span class="checkmark"></span>
              </label>
            </div> -->
            <!-- <div class="shopping__detail--time--con1-time"></div>
            <div class="shopping__detail--time--con1-time">
              <label class="checkbox">
                <span class="ttt">ساعت ۱۵ تا ۱۸</span>
                <input type="radio" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="shopping__detail--time--con1-time">
              <label class="checkbox">
                <span class="ttt">ساعت ۱۸ تا ۲۱</span>
                <input type="radio" />
                <span class="checkmark"></span>
              </label>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="shopping__info-container" id="shopping-cart">
      <div class="shopping__info-container--pri">
        قیمت کالاها ({{ info.co.toLocaleString("fa").toPersianDigits() }})
        <span>{{
          (info.ben + info.total + info.wallet)
            .toLocaleString("fa")
            .toPersianDigits()
        }}</span>
        تومان
      </div>
      <div class="shopping__info-container--dec">
        سود شما از این خرید
        <span>{{ info.ben.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <hr class="mmmm" />
      <!-- <div class="shopping__info-container--totall">
        جمع
        <span>{{ info.total.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <hr /> -->
      <div class="shopping__info-container--cash">
        مبلغ قابل پرداخت
        <span>{{ this.allcart.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <hr v-if="info.wallet != null" />
      <div v-if="info.wallet >= 0" class="shopping__info-container--pri">
        موجودی کیف پول
        <span>{{ info.wallet.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <div v-if="info.wallet < 0" class="shopping__info-container--pri">
        شما مبلغ
        {{ (info.wallet * -1).toLocaleString("fa").toPersianDigits() }}
        تومان بدهکار هستید.
      </div>
      <div class="shopping__info-container--btn-con">
        <a
          v-if="this.valid.length == 0"
          onclick="return false"
          class="shopping__info-container--btn-con--btn--can"
        >
          اتصال به درگاه پرداخت
        </a>
        <a
          v-else
          @click.prevent="buy"
          class="shopping__info-container--btn-con--btn"
        >
          اتصال به درگاه پرداخت
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      texte: "",
      decode: [],
      decodee: [],
      time: "",
      delivery_date: "",
      edit_show: false,
      delete_add: "",
      valid: [],
      info: {
        wallet: "",
        total: "",
        ben: "",
        co: "",
      },
      fday: "",
      lday: "",
      allcart: "",
      asdf: "",
      asdff: [],
      eddit: {
        tel: "",
        fname: "",
        lname: "",
        zipc: "",
        pri: [],
        city: "",
        add: "",
        pla: "",
        vah: "",
        nanu: "",
        pho: "",
      },
      idk: {},
      create: {
        tel: "",
        fname: "",
        lname: "",
        zipc: "",
        pri: [],
        city: "",
        add: "",
        pla: "",
        vah: "",
        nanu: "",
        pho: "",
      },
      options_city: [
        { id: 1, name: "آذربایجان شرقی" },
        { id: 2, name: "آذربایجان غربی" },
        { id: 3, name: "اردبیل" },
        { id: 4, name: "اصفهان" },
        { id: 5, name: "البرز" },
        { id: 6, name: "ایلام" },
        { id: 7, name: "بوشهر" },
        { id: 8, name: "تهران" },
        { id: 9, name: "چهارمحال و بختیاری" },
        { id: 10, name: "خراسان جنوبی" },
        { id: 11, name: "خراسان رضوی" },
        { id: 12, name: "خراسان شمالی" },
        { id: 13, name: "خوزستان" },
        { id: 14, name: "زنجان" },
        { id: 15, name: "سمنان" },
        { id: 16, name: "سیستان و بلوچستان" },
        { id: 17, name: "فارس" },
        { id: 18, name: "قزوین" },
        { id: 19, name: "قم" },
        { id: 20, name: "کردستان" },
        { id: 21, name: "کرمان" },
        { id: 22, name: "کرمانشاه" },
        { id: 23, name: "کهگیلویه و بویراحمد" },
        { id: 24, name: "گلستان" },
        { id: 25, name: "گیلان" },
        { id: 26, name: "لرستان" },
        { id: 27, name: "مازندران" },
        { id: 28, name: "مرکزی" },
        { id: 29, name: "هرمزگان" },
        { id: 30, name: "همدان" },
        { id: 31, name: "یزد" },
      ],
      m_total: "",
      create_show: false,
      addpri: "",
      address: "",
      post: "2",
      dateee: [],
      add_list: [],
      idd: "3000",
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 0,
        // slidesPerGroup: 6,
        // loop: true,
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            // spaceBetween: 150
          },
        },
        loopFillGroupWithBlank: true,
        lazy: true,
        // breakpoints: {
        //   1024: {
        //     slidesPerView: 4,
        //     spaceBetween: 15
        //   },
        //   768: {
        //     slidesPerView: 3,
        //     spaceBetween: 10
        //   },
        //   640: {
        //     slidesPerView: 2,
        //     spaceBetween: 20
        //   },
        //   320: {
        //     slidesPerView: 1,
        //     slidesPerGroup: 1,
        //     spaceBetween: 150
        //   }
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  watch: {
    post: function (data) {
      // console.log(this.idk, "booooooooooooooon");
      if (data == 2) {
        // console.log("cheraaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        this.allcart = this.m_total;
      } else if (data == 3) {
        this.allcart =
          this.m_total +
          this.idk.delivery_pre_prices.tipax -
          this.idk.delivery_pre_prices.post;
      } else if (data == 4) {
        this.allcart =
          this.m_total +
          this.idk.delivery_pre_prices.freight -
          this.idk.delivery_pre_prices.post;
      } else if (data == 1) {
        this.allcart =
          this.m_total +
          this.idk.delivery_pre_prices.tehran_courier -
          this.idk.delivery_pre_prices.post;
      }
      // else {
      //   this.allcart = this.m_total + this.idk.delivery_pre_prices ;
      // }
    },
  },
  mounted() {},
  // computed: {
  //   checkday(e) {
  //     console.log(
  //       e,
  //       "qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqwwwwwwwwwwwwwwwwwwwwwwwww"
  //     );
  //     return true;
  //   }
  // },
  methods: {
    checkday(e1, e2) {
      if (e1 == "پنج‌شنبه" || e1 == "آدینه") {
        return false;
      } else if (e2 == true) {
        return false;
      } else {
        return true;
      }
    },
    nameWithLang({ id, amount }) {
      return `${amount.toLocaleString("fa")} تومان`;
    },
    codeinss(actionName) {
      var that = this;
      that.$store.state.load = true;

      // console.log(actionName);
      $.ajax({
        url: that.$store.state.url + "api/v1/shop/discount/set/" + 0 + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "POST",
        success: function (data, textStatus, request) {
          that.$toastr.s(data);
          $.ajax({
            url: that.$store.state.url + "api/v1/shop/cart/info/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.info.wallet = data.wallet;
              that.info.co = data.total_count;
              that.info.ben = data.total_profit;
              that.allcart = data.total_price;
              // that.allcart = data.total_price + data.post_delivery_preprice;
              that.info.total = data.total_price;
              if (that.post == 2) {
                // that.m_total = data.total_price + data.post_delivery_preprice;
                that.allcart = data.total_price + data.delivery_pre_prices.post;
              } else if (that.post == 3) {
                that.allcart =
                  data.total_price + data.delivery_pre_prices.tipax;
                console.log(that.allcart);
              } else if (that.post == 4) {
                that.allcart =
                  data.total_price + data.delivery_pre_prices.freight;
              } else {
                // that.m_total = data.total_price - data.post_delivery_preprice;
                that.allcart = data.total_price;
              }
              // that.m_total = data.total_price;
              that.m_total = data.total_price + data.delivery_pre_prices.post;

              that.asdf = data.discount_id;
              if (that.asdf) {
                for (var i = 0; i < that.decode.length; i++) {
                  // console.log(that.decode[i].id);
                  if (that.asdf == that.decode[i].id) {
                    that.decodee = that.decode[i];
                    // console.log(that.decode[i].id, "this is it");
                  }
                }
              }
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
              // console.log(request);
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        },
        error: function (request, textStatus, errorThrown) {
          // console.log(request.responseJSON);

          for (var i = 0; i < request.responseJSON.length; i++) {
            that.$toastr.e(request.responseJSON[i]);
          }
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else if (request.state == 404) {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
    },
    codeins(actionName) {
      // console.log(e.target.name);
      var that = this;
      that.$store.state.load = true;

      // console.log(actionName);
      // that.$store.state.load = false;

      // console.log(e.target.name);

      // //  else if (!that.decodee.id) {
      // //   that.$toastr.e("مقدار کد تخفیف نمی توانید خالی باشد");
      // // that.$store.state.load = false;
      // // }
      // console.log(this.decodee.id);

      // if (e.target.name == "err") {
      //   this.decodee.id = 0;
      //   // that.$store.state.load = false;
      // }
      // if (that.decodee) {
      //   if (that.decodee.id == undefined || that.decodee == null) {
      //     that.$toastr.e("مقدار کد تخفیف نمی توانید خالی باشد");
      //     that.$store.state.load = false;
      //   } else {
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/shop/discount/set/" +
          actionName.id +
          "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "POST",
        success: function (data, textStatus, request) {
          that.$toastr.s(data);
          $.ajax({
            url: that.$store.state.url + "api/v1/shop/cart/info/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.info.wallet = data.wallet;
              that.info.co = data.total_count;
              that.info.ben = data.total_profit;
              // that.allcart = data.total_price;
              // that.allcart = data.total_price + data.post_delivery_preprice;
              that.info.total = data.total_price;
              if (that.post == 2) {
                // that.m_total = data.total_price + data.post_delivery_preprice;
                that.allcart = data.total_price + data.delivery_pre_prices.post;
              } else if (that.post == 3) {
                that.allcart =
                  data.total_price + data.delivery_pre_prices.tipax;
                console.log(that.allcart);
              } else if (that.post == 4) {
                that.allcart =
                  data.total_price + data.delivery_pre_prices.freight;
              } else {
                // that.m_total = data.total_price - data.post_delivery_preprice;
                that.allcart = data.total_price;
              }
              // that.m_total = data.total_price + data.post_delivery_preprice;
              // that.m_total = data.total_price;
              that.m_total = data.total_price + data.delivery_pre_prices.post;

              that.asdf = data.discount_id;
              if (that.asdf) {
                for (var i = 0; i < that.decode.length; i++) {
                  // console.log(that.decode[i].id);
                  if (that.asdf == that.decode[i].id) {
                    that.decodee = that.decode[i];
                    // console.log(that.decode[i].id, "this is it");
                  }
                }
              }
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
              // console.log(request);
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        },
        error: function (request, textStatus, errorThrown) {
          // console.log(request.responseJSON);

          for (var i = 0; i < request.responseJSON.length; i++) {
            that.$toastr.e(request.responseJSON[i]);
          }
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else if (request.state == 404) {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
      // }
      // } else {
      //   that.$toastr.e("مقدار کد تخفیف نمی توانید خالی باشد");
      //   that.$store.state.load = false;
      // }
    },
    buy() {
      var that = this;
      // console.log(this.address);
      var del = this.delivery_date.replace(/\//g, "-");
      // console.log(del);
      // console.log(this.post);
      // console.log(this.time);
      that.$store.state.load = true;
      // if (this.post != 1) {
      //   (this.time = ""), (del = "");
      // }
      if (this.address.length == 0) {
        that.$toastr.e("لطفا آدرس خود را انتخاب کنید.");
        that.$store.state.load = false;
      } else if (this.post.length == 0) {
        that.$toastr.e("لطفا نحوه ارسال را انتخاب کنید.");
        that.$store.state.load = false;
      } else if (this.addpri == 8 && del.length == 0 && this.post == 1) {
        that.$toastr.e("لطفا تاریخ ارسال را انتخاب کنید.");
        that.$store.state.load = false;
      }
      // else if (this.addpri == 8 && this.time.length == 0 && this.post == 1) {
      //   that.$toastr.e("لطفا زمان ارسال را انتخاب کنید.");
      //   that.$store.state.load = false;
      // }
      else {
        $.ajax({
          url: that.$store.state.url + "api/v1/shop/invoice/update/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          data: {
            description: this.texte,
            address: this.address,
            delivery_type: this.post,
            delivery_date: del,
            // delivery_time: this.time,
          },
          type: "PUT",
          success: function (data, textStatus, request) {
            that.$store.state.load = false;
            that.$toastr.s("درحال اتصال به درگاه");
            // console.log(data);
            window.location.href = data;
          },
          error: function (request, textStatus, errorThrown) {
            console.log("re");
            if (request.responseJSON) {
              that.$toastr.e(request.responseJSON);
            }
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    test() {},
    edit_add() {
      var that = this;
      that.$store.state.load = true;
      $.ajax({
        url: that.$store.state.url + "api/v1/accounts/adr/" + this.d_id + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        data: {
          phone: this.eddit.tel,
          cellphone: this.eddit.pho,
          province: this.eddit.pri.id,
          city: this.eddit.city,
          address: this.eddit.add,
          zip_code: this.eddit.zipc,
          first_name: this.eddit.fname,
          last_name: this.eddit.lname,
          national_no: this.eddit.nanu,
        },
        type: "PATCH",
        success: function (data, textStatus, request) {
          that.$toastr.s(data);
          $.ajax({
            url: that.$store.state.url + "api/v1/accounts/adr/",
            crossDomain: true,
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.add_list = data;

              that.$store.state.load = false;
              that.edit_show = false;
            },
            error: function (request, textStatus, errorThrown) {
              console.log("blue");
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          console.log("blue");
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
    },
    open_edit(e) {
      var that = this;
      this.edit_show = true;
      // console.log(e.target.parentElement.lastElementChild.value);
      this.d_id = e.target.parentElement.lastElementChild.value;
      that.$store.state.load = true;
      $.ajax({
        url: that.$store.state.url + "api/v1/accounts/adr/" + this.d_id + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.eddit.add = data.address;
          that.eddit.pho = data.cellphone;
          that.eddit.city = data.city;
          that.eddit.fname = data.first_name;
          that.eddit.lname = data.last_name;
          that.eddit.tel = data.phone;
          that.eddit.zipc = data.zip_code;
          that.eddit.nanu = data.national_no;

          var boom = data.province;
          for (var h = 0; h < that.options_city.length; h++) {
            if (boom == that.options_city[h].id) {
              that.eddit.pri = that.options_city[h];
            }
          }
          that.$store.state.load = false;
        },
        error: function (request, textStatus, errorThrown) {
          console.log("blue");
        },
        complete: function () {},
      });
    },
    delete_add_cart(e) {
      var id = e.target.parentElement.lastElementChild.value;
      var that = this;
      // console.log(this.create);
      var that = this;
      that.$store.state.load = true;
      $.ajax({
        url: that.$store.state.url + "api/v1/accounts/adr/" + id + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "DELETE",
        success: function (data, textStatus, request) {
          that.$toastr.s(data);
          $.ajax({
            url: that.$store.state.url + "api/v1/accounts/adr/",
            crossDomain: true,
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.add_list = data;

              that.$store.state.load = false;
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          // console.log("blue");
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
    },
    create__address() {
      // console.log(this.create);
      var that = this;
      that.$store.state.load = true;
      if (
        this.create.tel.length == 0 ||
        this.create.pho.length == 0 ||
        this.create.pri.length == 0 ||
        this.create.city.length == 0 ||
        this.create.add.length == 0 ||
        this.create.zipc.length == 0 ||
        this.create.fname.length == 0 ||
        this.create.lname.length == 0
      ) {
        that.$toastr.e("لطفا فیلد های تعیین شده را پر کنید.");
        that.$store.state.load = false;
      } else if (this.create.pho.length <= 11 && this.create.pho.length >= 15) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.create.tel.length != 11) {
        that.$toastr.e("لطفا شماره ثابت معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.create.city.length >= 127) {
        that.$toastr.e("طول نام شهر وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.create.zipc.length != 10) {
        that.$toastr.e("لطفا کد پستی معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (
        this.create.nanu.length != 10 &&
        this.create.nanu.length != 0
      ) {
        that.$toastr.e("لطفا کد ملی معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.create.fname.length >= 150) {
        that.$toastr.e("طول نام وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.create.lname.length >= 150) {
        that.$toastr.e(
          "طول نام خانوادگی وارد شده نباید بیشتر از ۱۵۰ حرف باشد."
        );
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/adr/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          data: {
            phone: this.create.tel,
            cellphone: this.create.pho,
            province: this.create.pri.id,
            city: this.create.city,
            address: this.create.add,
            zip_code: this.create.zipc,
            first_name: this.create.fname,
            last_name: this.create.lname,
            national_no: this.create.nanu,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            that.$toastr.s(data);
            $.ajax({
              url: that.$store.state.url + "api/v1/accounts/adr/",
              crossDomain: true,
              headers: {
                Authorization: "Bearer" + " " + localStorage.getItem("profile"),
              },
              xhrFields: {
                withCredentials: true,
              },
              type: "GET",
              success: function (data, textStatus, request) {
                that.add_list = data;
                that.$store.state.load = false;
                that.create_show = false;
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {},
            });
          },
          error: function (request, textStatus, errorThrown) {
            for (var i = 0; i < request.responseJSON.length; i++) {
              that.$toastr.e(request.responseJSON[i]);
            }
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    booooooom() {
      console.log("red");
    },
    prev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.swiper.$swiper.slideNext();
    },
  },
  created() {
    var that = this;
    this.$store.state.load = true;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    var that = this;
    that.$store.state.load = true;
    console.log("created");

    $.ajax({
      url: that.$store.state.url + "api/v1/shop/invoice/delivery_msgs/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        console.log(data);
        that.idk = data;

        console.log(that.idk.tehran_courier_days[0], "ffffffffffffffffffffff");
        console.log(that.idk.tehran_courier_days[1], "ffffffffffffffffffffff");
        var moment = require("jalali-moment");
        const pholiday = require("pholiday");
        for (
          var i = that.idk.tehran_courier_days[0];
          i <= that.idk.tehran_courier_days[1];
          i++
        ) {
          moment.locale("fa"); // default locale is en
          var item = {
            fayear: moment().add(i, "days").format("l"),

            month: moment().add(i, "days").format("MMMM"),

            day: moment().add(i, "days").format("DD"),

            perday: moment().add(i, "days").format("dddd"),

            enyear: moment().locale("en").add(i, "days").format("YYYY/MM/DD"),

            ishol: pholiday(
              moment().add(i, "days").format("l"),
              "jYYYY/jMM/jDD"
            ).isHoliday(),
          };
          that.dateee.push(item);
          // console.log(that.dateee, "vaaaaaaaaaaaaaaaaaaaay");
        }
      },
      error: function (request, textStatus, errorThrown) {
        console.log("blue");
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });

    $.ajax({
      url: that.$store.state.url + "api/v1/accounts/adr/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        console.log(data);
        that.add_list = data;
      },
      error: function (request, textStatus, errorThrown) {
        console.log("blue");
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
    $.ajax({
      url: that.$store.state.url + "api/v1/shop/discount/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        console.log(data);
        that.decode = data;
      },
      error: function (request, textStatus, errorThrown) {
        console.log("blue");
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
    $.ajax({
      url: that.$store.state.url + "api/v1/shop/order/vlist/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.valid = data;
        // console.log(that.valid, "valiiiiiiiiiiiiiiiiiiiiiiiiiiiiiid");
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("blue");
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });

    $.ajax({
      url: that.$store.state.url + "api/v1/shop/cart/info/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data.delivery_pre_prices, "ohohohohohohohoh");
        that.info.wallet = data.wallet;
        that.info.co = data.total_count;
        that.info.ben = data.total_profit;
        // that.allcart = data.total_price;
        that.allcart = data.total_price + data.delivery_pre_prices.post;
        that.info.total = data.total_price;
        that.m_total = data.total_price + data.delivery_pre_prices.post;
        // that.m_total = data.total_price;
        that.asdf = data.discount_id;
        if (that.asdf) {
          for (var i = 0; i < that.decode.length; i++) {
            // console.log(that.decode[i].id);
            if (that.asdf == that.decode[i].id) {
              that.decodee = that.decode[i];
              // console.log(that.decode[i].id, "this is it");
            }
          }
        }
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("blue");
        // console.log(request);
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.in3 {
  margin-top: 1em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  .i7 {
    width: 49%;
    margin-bottom: 0.5em;
  }
  .i8 {
    width: 100%;
    margin-bottom: 0.5em;
  }
}
.in2 {
  display: flex;
  margin-bottom: 0.5em;

  .b1 {
    width: 20%;
    margin-left: 0.5em;
  }
  .b2 {
    width: 20%;
    margin-left: 0.5em;
  }
  .b3 {
    width: 100%;
    // margin-left: 0.5em;
  }
  input {
    width: 35%;
  }
}
.in1 {
  width: 100%;
  display: flex;
  //   background: red;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 0.5em;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
}
.bo {
  // background: red;
  margin-bottom: 0.05em;
  width: 50%;
  margin-right: 0.5em;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
}
.bo1 {
  // background: blue;ZZ
  width: 50%;
  // margin: 0.6em;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
}
.in33 {
  width: 100%;
  margin-top: 2em;
  display: flex;
  //   background: red;
  justify-content: space-between;
  align-items: flex;
  margin-bottom: 0.5em;
  flex-direction: row;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
  .bo33 {
    // background: blue;ZZ
    width: 100%;
    // margin: 0.6em;
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
  .bo {
    // background: red;
    margin-bottom: 0.05em;
    width: 50%;
    margin-right: 0.5em;
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
}
.la {
  //   color: red;
  font-size: 0.8em;
  display: block;
  padding-bottom: 0.5em;
}
.holi {
  background: #ccc;
  pointer-events: none;
}
.shopping {
  width: 100%;
  min-height: 100vh;
  margin-top: 7.9em;
  display: flex;
  //   justify-content: center;
  //   align-items: center;
  direction: rtl;
  position: relative;
  @media screen and (max-width: 1200px) {
    font-size: 0.9em;
  }
  @media screen and (max-width: 1000px) {
    // flex-direction: column-reverse;
    font-size: 0.9em;
    // margin-top: 13em;
    flex-direction: column-reverse;
  }
  @media screen and (max-width: 500px) {
    flex-direction: column-reverse;
  }
  &__info-container {
    margin-right: 1em;
    width: 25%;
    margin-right: auto;
    margin-left: auto;
    height: 0%;
    // height: 250px;
    margin-top: 2em;
    background: var(--main-color);
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    -webkit-box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
    box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 18%;
    left: 2%;
    margin-bottom: 1em;
    // z-index: 700;
    @media screen and (max-width: 1200px) {
      font-size: 0.9em;
      // height: 210px;
      height: 0%;
    }
    @media screen and (max-width: 1000px) {
      width: 97%;
      font-size: 0.7em;
      height: auto;
      position: static;
      margin-top: 3em;
    }
    @media screen and (max-width: 500px) {
      width: 97%;
      font-size: 0.7em;
      height: auto;
      position: static;
    }
    &--btn-con {
      cursor: pointer;
      height: 65px;
      // height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      font-size: 0.65em;
      z-index: 5;
      @media screen and (max-width: 1000px) {
        height: 50px;
        position: fixed;
        bottom: 0%;
        left: 0;
        right: 0;
        // z-index: 9000000000 !important;
        font-size: 0.9em;
        background: var(--main-color);
      }
      @media screen and (max-width: 500px) {
        height: 50px;
        position: fixed;
        bottom: 0%;
        left: 0;
        right: 0;
        // z-index: 9000000000 !important;
        background: var(--main-color);
        font-size: 0.9em;
      }
      &--btn--can {
        height: auto;
        background: var(--main-color);
        width: 98%;
        background: gray;
        border-radius: 8px;
        text-align: center;
        text-decoration: none;
        padding: 1em;
        margin: 0 auto;
        color: var(--main-color);
        // margin-top: 2em;
        z-index: 7000000;
        font-size: 1.2em;
        @media screen and (max-width: 500px) {
          height: auto;
          margin-top: 0;
          display: block;
        }
      }
      &--btn {
        height: auto;
        width: 98%;
        background: var(--sub-color);
        border-radius: 8px;
        text-align: center;
        text-decoration: none;
        padding: 1em;
        margin: 0 auto;
        color: var(--main-color);

        z-index: 7000000;
        font-size: 1.2em;
        @media screen and (max-width: 500px) {
          height: auto;
          margin-top: 0;
          display: block;
        }
      }
    }
    &--pri {
      display: flex;
      padding: 1em;
      color: #aaa;
      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
    &--cash {
      display: flex;
      padding: 1em;
      color: var(--font-color);
      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
    &--totall {
      display: flex;
      padding: 1em;
      color: var(--font-color);
      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
    &--dec {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5em 1em;
      color: var(--shrink);
      margin-bottom: 1em;

      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
  }
  &--form {
    position: fixed;
    width: 600px;
    height: 650px;
    overflow-y: visible;
    overflow-x: hidden;
    background: var(--main-color);
    padding: 3em 3em;
    z-index: 900;
    top: 1%;
    left: 50%;
    transform: translate(-50%);
    box-shadow: 0 0 400px 400px rgba(0, 0, 0, 0.103);
    border-radius: 8px;
    direction: rtl;
    // z-index: 100000000000000000000;
    @media screen and (max-width: 500px) {
      font-size: 1em;
      width: 99%;
      height: 90vh;
      top: 50%;
      padding: 2em 1em 2em 1em;
      // padding-top: 7em;
      left: 0;
      transform: translate(0, -50%);
    }
    input {
      background: var(--main-color);
      border: 1px solid rgba(204, 204, 204, 0.39);
      padding: 0.53em;
      width: 100%;
      border-radius: 5px;
      font-family: "yekan";
      color: var(--font-color);
      //   margin-bottom: ;
      @media screen and (max-width: 500px) {
        font-size: 1em;
        // width: 90%;
        // min-height: 10vh;
      }
    }
    &-close {
      position: absolute;
      left: 0;
      top: 0;
      transform: translate(50%, 30%);
      font-size: 2em;
      color: var(--shrink);
    }
  }
  &__detail {
    margin-top: 2em;
    width: 70%;
    height: auto;
    // background: red;
    margin-right: 2em;
    @media screen and (max-width: 1000px) {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 0;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 0;
    }
    &--texte {
      color: var(--font-color);
      font-family: "yekan";
      margin-top: 1em;
      padding: 1em;
      border: none;
      background: var(--bg-color);
      border-radius: 5px;
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      height: 150px;
      min-height: 150px;
      max-height: 150px;
    }
    &--time {
      min-height: 200px;
      background: var(--main-color);
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      margin-bottom: 1em;
      //   -webkit-box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      padding: 1em;
      @media screen and (max-width: 1000px) {
        width: 97%;
        font-size: 0.8em;
        margin-bottom: 0.5em;
      }
      @media screen and (max-width: 500px) {
        width: 97%;
        font-size: 0.8em;
        margin-bottom: 0.5em;
      }
      &-h3 {
        margin-right: 1em;
        color: black;
        margin-top: 1em;
        padding-bottom: 1em;
        border-bottom: 1px solid #e6e6e6;
      }
      &-p {
        margin-bottom: 1em;
        margin-top: 1em;
        // margin-bottom: 1em;
        margin-right: 1em;
        color: var(--shrink);
        // color: black;
      }
      &--con1 {
        // background: blue;
        width: 100%;
        min-height: 100px;
        padding: 1em;

        &-time {
          border-bottom: 1px solid rgba(216, 231, 235, 0.205);
          .ttt {
            margin-right: 3em;
          }
        }
      }
      &--con {
        display: flex;
        align-items: center;
        justify-content: center;
        // background: red;
        &-day {
          width: 245.667px;
          //   border-bottom: 1px solid black;
          font-size: 0.8em;
          background: var(--bg-color);
          a {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 1em;
            height: 100%;
            width: 100%;
            color: var(--font-color);
            // background: red;
            text-decoration: none;
          }
        }
      }
    }
    &--marsole {
      min-height: 200px;
      background: var(--main-color);
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      margin-bottom: 1em;
      //   -webkit-box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      padding: 1em;
      @media screen and (max-width: 1000px) {
        display: flex;
        flex-direction: column;
        width: 97%;
        flex-wrap: wrap;
      }
      @media screen and (max-width: 500px) {
        display: flex;
        flex-direction: column;
        width: 97%;
        flex-wrap: wrap;
      }
      &-h3 {
        margin-right: 1em;
        color: black;
        margin-top: 1em;
        padding-bottom: 1em;
        border-bottom: 1px solid #e6e6e6;
      }
      &-p {
        margin-top: 1em;
        // margin-bottom: 1em;
        margin-right: 1em;
        color: var(--shrink);
        // color: black;
      }
      &-items {
        margin-top: 2em;
        display: flex;
        flex-wrap: wrap;
        @media screen and (max-width: 1000px) {
          display: flex;
          flex-wrap: wrap;
          // flex-direction: column;
          // width: 97%;
          justify-content: space-between;
          align-items: center;
        }
        @media screen and (max-width: 500px) {
          display: flex;
          flex-wrap: wrap;
          // flex-direction: column;
          // width: 97%;
          justify-content: space-between;
          align-items: center;
        }
        &-item {
          box-shadow: 0 0 1px rgba(0, 0, 0, 0.089);
          border: 1px solid #ccc;
          padding: 2em 2em;
          width: 20%;
          border-radius: 8px;
          margin-left: 0.5em;
          background: var(--main-color);
          text-decoration: none;

          //   background: red;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          //   background: red;
          width: 24%;
          @media screen and (max-width: 700px) {
            display: flex;
            flex-direction: column;
            width: 32%;
            // margin-right: 0.2em;
            margin-bottom: 0.5em;
          }
          @media screen and (max-width: 500px) {
            display: flex;
            flex-direction: column;
            width: 45%;
            // margin-right: 0.2em;
            margin-bottom: 0.5em;
          }
          &-img {
            width: 100px;
            height: 100px;
          }
          &-color {
            display: flex;
            // background: red;
            flex-direction: row-reverse;
            &-div {
              display: flex;
              //   background: red !important;
              margin-left: 0.3em;
              //   padding: 0.5em;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              border: 1px solid var(--font-color);
              margin-top: 0.45em;
            }
          }
        }
      }
    }
    &--address {
      min-height: 200px;
      background: var(--main-color);
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      margin-bottom: 1em;
      //   -webkit-box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      padding: 1em;
      @media screen and (max-width: 1000px) {
        display: flex;
        flex-direction: column;
        width: 97%;
        font-size: 0.8em;
      }
      @media screen and (max-width: 500px) {
        display: flex;
        flex-direction: column;
        width: 97%;
        font-size: 0.8em;
      }
      &-h3 {
        margin-right: 1em;
        color: black;
        margin-top: 1em;
        padding-bottom: 1em;
        border-bottom: 1px solid #e6e6e6;
      }
      &-p {
        margin-top: 1em;
        // margin-bottom: 1em;
        margin-right: 1em;
        color: var(--shrink);
        // color: black;
      }
      &-items {
        padding: 1em;
        // background: red;
        display: flex;
        // justify-content: space-between;
        cursor: pointer;
        @media screen and (max-width: 500px) {
          flex-direction: column;
          width: 100%;
        }
        &-del {
          width: 50%;
          //   background: red;
          padding: 0.75em;
          border-radius: 8px;
          border: 1px solid var(--font-color);
          font-size: 0.8em;
          text-decoration: none;
          color: var(--font-color);
          margin-left: 0.5em;
          @media screen and (max-width: 500px) {
            width: 100%;
            margin-bottom: 0.5em;
          }
          svg {
            margin-left: 0.5em;
            margin-right: 0.5em;
          }
        }
        &-add {
          color: var(--font-color);
          text-decoration: none;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          //   background: red;
          border: 1px dashed var(--shrink);
          padding: 1em;
          width: 33%;
          border-radius: 8px;
          @media screen and (max-width: 500px) {
            width: 100%;
          }
          svg {
            margin-bottom: 0.5em;
          }
        }
        &-item {
          box-shadow: 0 0 1px rgba(0, 0, 0, 0.089);
          border: 2px solid #ccc;
          padding: 2em 2em;
          width: 33%;
          border-radius: 8px;
          margin-left: 0.5em;
          background: var(--main-color);
          text-decoration: none;
          //   background: red;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          @media screen and (max-width: 500px) {
            width: 100%;
            margin-bottom: 0.5em;
          }
          &-edit {
            // width: auto;
            text-align: left;
            // background: red;
            // display: block;
            margin-right: auto;
            font-size: 0.9em;
            // margin-top: 5em;
            &-del {
              padding-left: 1em;
              border-left: 1px solid rgba(204, 204, 204, 0.397);
            }
            &-edi {
              padding-right: 0.5em;
            }
            a {
              color: var(--sub-color);
              text-decoration: none;
            }
          }
          &-add {
            margin-bottom: 2em;
            color: black;
          }
          &-zipc {
            color: #ccc;
            margin-bottom: 1em;
            font-size: 0.8em;
            svg {
              color: var(--sub-color);
              margin-left: 0.2em;
            }
          }
          &-pho {
            color: #ccc;
            font-size: 0.8em;
            svg {
              color: var(--sub-color);
              margin-left: 0.2em;
            }
            margin-bottom: 1em;
          }
          &-name {
            color: #ccc;
            font-size: 0.8em;
            svg {
              color: var(--sub-color);
              margin-left: 0.2em;
            }
            margin-bottom: 1em;
          }
        }
      }
    }
  }
}
.aaa {
  border: 2px solid var(--shrink);
}
.aaaa {
  color: var(--main-color) !important;
  background: var(--shrink);
  //   border-top: 2px solid var(--shrink);
}
.swiper-button-next {
  border-radius: 50%;
  font-size: 0.2em !important;

  // right: 10px;
  padding: 10px;
  top: 50%;
  transform: translate(-25%, -0%);
  color: var(--sub-color) !important;

  fill: var(--sub-color) !important;
  stroke: var(--sub-color) !important;
  display: none;
  @media screen and (max-width: 1000px) {
    display: none;
  }
}
.swiper-button-prev {
  border-radius: 50%;
  font-size: 0.2em !important;

  // right: 10px;
  padding: 10px;
  top: 50%;
  transform: translate(25%, -0%);
  color: var(--sub-color) !important;

  fill: var(--sub-color) !important;
  stroke: var(--sub-color) !important;
  display: none;

  @media screen and (max-width: 1000px) {
    display: none;
  }
}
:root {
  --swiper-navigation-size: 17px;
  --swiper-navigation-size: 17px !important;
}
.checkbox {
  direction: rtl;
  display: flex;
  // justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin-bottom: 20px;
  cursor: pointer;
  margin-top: 0.8em;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  // background: red;
  width: 100%;
}

/* Hide the browser's default checkbox */
.checkbox input {
  direction: rtl;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-100%, 30%);
  border-radius: 50%;
  height: 15px;
  width: 15px;
  background-color: var(--main-color);
  border: 1px solid #ccc;
  direction: rtl;
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: var(--bg-color);
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: var(--shrink);
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  left: 5px;
  top: 3px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.rrrr {
  //   margin-bottom: 1em;
  margin: 0 auto;
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 1em;
  background-color: #cfd8dc;
}
.bbb {
  display: block;
  width: 100%;
  border: none;
  color: var(--main-color);
  background: var(--sub-color);
  padding: 1em;
  font-family: "yekan";
  margin-top: 2em;
  border-radius: 8px;
  @media screen and (max-width: 500px) {
    font-size: 0.8em;
    margin-bottom: 2em;
  }
}
.mmmm {
  width: 95%;
  margin-right: auto;
  margin-left: auto;
  border: none;
  height: 1px;
  //   margin-top: 1em;
  background-color: #cfd8dc;
}
.fixed {
  position: fixed;
  top: 10%;
  //   margin-left: 720px;
  //   background-color: #0f0 !important;
}
$accentcolor: #ef3954;
$lightcolor: #fff;
$darkcolor: #444;

.radiobtn {
  position: relative;
  display: block;
  label {
    display: block;
    background: lighten($accentcolor, 30%);
    color: var(--font-color);
    // padding-right: 2em;
    border-radius: 5px;
    padding: 10px 40px;
    border: 2px solid lighten($accentcolor, 20%);
    margin-bottom: 5px;

    cursor: pointer;
    &:after,
    &:before {
      content: "";
      position: absolute;
      right: 11px;
      top: 11px;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      background: lighten($accentcolor, 15%);
    }
    &:before {
      background: transparent;
      transition: 0.1s width cubic-bezier(0.075, 0.82, 0.165, 1) 0s,
        0.3s height cubic-bezier(0.075, 0.82, 0.165, 2) 0.1s;
      z-index: 2;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 13px;
      background-position: center;
      width: 0;
      height: 0;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS4zIDEzLjIiPiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE0LjcuOGwtLjQtLjRhMS43IDEuNyAwIDAgMC0yLjMuMUw1LjIgOC4yIDMgNi40YTEuNyAxLjcgMCAwIDAtMi4zLjFMLjQgN2ExLjcgMS43IDAgMCAwIC4xIDIuM2wzLjggMy41YTEuNyAxLjcgMCAwIDAgMi40LS4xTDE1IDMuMWExLjcgMS43IDAgMCAwLS4yLTIuM3oiIGRhdGEtbmFtZT0iUGZhZCA0Ii8+PC9zdmc+);
    }
  }
  input[type="radio"] {
    display: none;
    position: absolute;
    width: 100%;
    appearance: none;
    &:checked + label {
      background: lighten($accentcolor, 15%);
      animation-name: blink;
      animation-duration: 1s;
      color: var(--main-color);
      border-color: $accentcolor;
      &:after {
        background: $accentcolor;
      }
      &:before {
        width: 20px;
        height: 20px;
      }
    }
  }
}

@keyframes blink {
  0% {
    background-color: lighten($accentcolor, 15%);
  }
  10% {
    background-color: lighten($accentcolor, 15%);
  }
  11% {
    background-color: lighten($accentcolor, 20%);
  }
  29% {
    background-color: lighten($accentcolor, 20%);
  }
  30% {
    background-color: lighten($accentcolor, 15%);
  }
  50% {
    background-color: lighten($accentcolor, 20%);
  }
  45% {
    background-color: lighten($accentcolor, 15%);
  }
  50% {
    background-color: lighten($accentcolor, 20%);
  }
  100% {
    background-color: lighten($accentcolor, 15%);
  }
}
.acc {
  font-family: "yekan";
  color: var(--main-color);
  background: var(--shrink);
  border-radius: 5px;
  border: none;
  padding: 0.5em 2em;
  margin: 0 1em;
  width: 150px;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  @media screen and (max-width: 500px) {
    width: 100%;
    // margin: 0;
    margin: 1em 0;
  }
}
.err {
  font-size: 0.8em;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  font-family: "yekan";
  color: var(--font-color);
  background: var(--main-color);
  border-radius: 5px;
  border: none;
  border: 1px solid var(--shrink);
  padding: 0.5em 2em;
  margin: 0 1em;
  @media screen and (max-width: 500px) {
    width: 100%;
    margin: 0;
  }
}
hr {
  width: 95%;
  margin-right: auto;
  margin-left: auto;
  border: none;
  height: 1px;
  //   margin-top: 1em;
  background-color: #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/components/shop/shopping.vue